import { GET_WATCH_LIST_ENTRY_BY_ID } from '../types';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  getWatchListEntryById,
  getWatchListEntryByIdPending,
  getWatchListEntryByIdFulfilled,
  getWatchListEntryByIdRejected,
} = createAsyncActions(GET_WATCH_LIST_ENTRY_BY_ID, 'getWatchListEntryById');


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/getWatchListEntryByIdActions.js